export const DEFAULT_CURRENCY = 'EUR';
export const DEFAULT_SITE_LOCATION = 'Unknown';
const DEFAULT_POS_ID = 0;
export const DEFAULT_DEP_POS_ID = DEFAULT_POS_ID;
export const DEFAULT_TAR_POS_ID = DEFAULT_POS_ID;
export const DEFAULT_RET_DATE = '';
